"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var stripe_js_1 = require("@stripe/stripe-js");
/**
 * Shown when a 202 carries no client secret: the payment's outcome is not
 * known, and a retry under the same key replays it rather than charging again.
 */
var CHALLENGE_UNAVAILABLE_MESSAGE = "We couldn't confirm this payment. Try again; you won't be charged twice.";
/**
 * Stripe 3D Secure Service
 *
 * Centralized service for handling 3D Secure authentication challenges
 * across the DriveScout frontend application.
 *
 * Usage:
 * 1. Submit payment to backend
 * 2. If response has requires_action: true, call handle3DSChallenge
 * 3. After successful authentication, call confirmOrderPayment or confirmFeePayment
 *
 * @example
 * const result = await Stripe3DSService.handle3DSChallenge(response.client_secret, publishableKey);
 * if (result.success) {
 *   await Stripe3DSService.confirmOrderPayment(orderId, paymentIntentId, confirmData, OrdersModel);
 * }
 */
var Stripe3DSService = /** @class */ (function () {
    function Stripe3DSService(OrdersModel, UsersModel) {
        this.stripeInstance = null;
        this.currentPublishableKey = "";
        this.OrdersModel = OrdersModel;
        this.UsersModel = UsersModel;
    }
    /**
     * Get or create a Stripe instance
     */
    Stripe3DSService.prototype.getStripe = function (publishableKey) {
        return __awaiter(this, void 0, void 0, function () {
            var stripe;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.stripeInstance && this.currentPublishableKey === publishableKey) {
                            return [2 /*return*/, this.stripeInstance];
                        }
                        return [4 /*yield*/, (0, stripe_js_1.loadStripe)(publishableKey)];
                    case 1:
                        stripe = _a.sent();
                        if (!stripe) {
                            throw new Error("Failed to load Stripe");
                        }
                        this.stripeInstance = stripe;
                        this.currentPublishableKey = publishableKey;
                        return [2 /*return*/, stripe];
                }
            });
        });
    };
    /**
     * Check if a response requires 3D Secure authentication. A 202 with no
     * client secret still counts, so it is never mistaken for a success;
     * handle3DSChallenge then reports it as not confirmed.
     */
    Stripe3DSService.prototype.isThreeDSecureRequired = function (response) {
        return !!response && response.requires_action === true;
    };
    /**
     * Handle 3D Secure authentication challenge
     *
     * Opens the Stripe 3DS modal/iframe for the customer to authenticate
     *
     * @param clientSecret - The PaymentIntent client_secret from the backend
     * @param publishableKey - The Stripe publishable key
     * @returns Promise resolving to ThreeDSecureResult
     */
    Stripe3DSService.prototype.handle3DSChallenge = function (clientSecret, publishableKey) {
        return __awaiter(this, void 0, void 0, function () {
            var stripe, result, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // No secret, no challenge: an unknown outcome, never a refusal
                        // (no errorType), so the payment's key is kept.
                        if (typeof clientSecret !== "string" || clientSecret === "") {
                            return [2 /*return*/, { success: false, error: CHALLENGE_UNAVAILABLE_MESSAGE }];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.getStripe(publishableKey)];
                    case 2:
                        stripe = _a.sent();
                        return [4 /*yield*/, stripe.handleNextAction({
                                clientSecret: clientSecret,
                            })];
                    case 3:
                        result = _a.sent();
                        if (result.error) {
                            return [2 /*return*/, {
                                    success: false,
                                    error: result.error.message || "3D Secure authentication failed",
                                    errorType: result.error.type,
                                    errorCode: result.error.code,
                                }];
                        }
                        if (result.paymentIntent &&
                            result.paymentIntent.status === "succeeded") {
                            return [2 /*return*/, {
                                    success: true,
                                    data: result.paymentIntent,
                                }];
                        }
                        // For requires_capture or other statuses, we still consider it successful
                        // as the authentication passed - the backend will handle the final status
                        if (result.paymentIntent) {
                            return [2 /*return*/, {
                                    success: true,
                                    data: result.paymentIntent,
                                }];
                        }
                        return [2 /*return*/, {
                                success: false,
                                error: "Unexpected result from 3D Secure authentication",
                            }];
                    case 4:
                        error_1 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                error: error_1.message || "An error occurred during 3D Secure authentication",
                            }];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Confirm an order payment after 3D Secure authentication
     *
     * @param orderId - The order ID
     * @param paymentIntentId - The Stripe PaymentIntent ID
     * @param confirmData - Additional confirmation data
     * @returns Promise resolving to the backend response
     */
    Stripe3DSService.prototype.confirmOrderPayment = function (orderId, paymentIntentId, confirmData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.OrdersModel.confirmPayment({
                        order_id: orderId,
                        payment_intent_id: paymentIntentId,
                        amount: confirmData.amount,
                    })];
            });
        });
    };
    /**
     * Confirm a fee payment after 3D Secure authentication
     *
     * @param studentId - The student ID
     * @param feeId - The fee ID
     * @param paymentIntentId - The Stripe PaymentIntent ID
     * @param confirmData - Additional confirmation data
     * @returns Promise resolving to the backend response
     */
    Stripe3DSService.prototype.confirmFeePayment = function (studentId, feeId, paymentIntentId, confirmData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.UsersModel.confirmFeePayment({
                        student_id: studentId,
                        fee_id: feeId,
                        payment_intent_id: paymentIntentId,
                        amount: confirmData.amount,
                    })];
            });
        });
    };
    return Stripe3DSService;
}());
Stripe3DSService.$inject = ["OrdersModel", "UsersModel"];
exports.default = Stripe3DSService;
